import axios from "axios"
import React, { useEffect, useState } from "react"
import { Col, Input, Row } from "reactstrap"
import DatePicker from "react-datepicker"
import Select from "react-select"
import MultipleValueTextInput from "react-multivalue-text-input"
import { useHistory } from "react-router-dom"
import UnAuthorizedComponent from "common/UnAuthorizedComponent"

const FilterUsers = ({ filteredValues, setFilteredValues }) => {
  const history = useHistory()

  const [users, setUsers] = useState([])
  const [roles, setRoles] = useState([])

  // **************** Authorization ******************************
  const [auth, setAuth] = useState(false)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/MenuUsersView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        data.splice(-1)
        let dataUsers = data.map(user => ({
          value: user[1].UserID,
          label: `${user[1].FirstName} ${user[1].LastName}`,
        }))
        setUsers(dataUsers)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  // console.log("filteredValues", filteredValues)

  if (auth) {
    return <UnAuthorizedComponent />
  }

  const handleInputChange = (e, field) => {
    const value = e.target.value
    setTimeout(() => {
      setFilteredValues(prevValues => ({
        ...prevValues,
        [field]: value,
      }))
    }, 1000)
  }

  return (
    <Row className="d-flex justify-content-center">
      {/* ****************************** Reference No ************************************ */}
      <Col sm={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
            <i className="bx bx-search-alt search-icon " />
            <MultipleValueTextInput
              onItemAdded={(item, allItems) => {
                if (allItems.length > 1) {
                  allItems.pop() // Remove the newly added item
                  return
                }
                setFilteredValues({
                  ...filteredValues,
                  reference_number: item,
                })
              }}
              onItemDeleted={(item, allItems) =>
                setFilteredValues({
                  ...filteredValues,
                  reference_number: "",
                })
              }
              type="number"
              name="reference_number"
              placeholder="Policy No ..."
              className="border-0 mt-1"
            />
          </div>
        </div>
      </Col>

      {/* ****************************** Mobile No ************************************ */}
      <Col sm={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
            <i className="bx bx-search-alt search-icon " />
            <MultipleValueTextInput
              onItemAdded={(item, allItems) => {
                if (allItems.length > 1) {
                  allItems.pop() // Remove the newly added item
                  return
                }
                setFilteredValues({
                  ...filteredValues,
                  mobile_number: item,
                })
              }}
              onItemDeleted={(item, allItems) =>
                setFilteredValues({
                  ...filteredValues,
                  mobile_number: "",
                })
              }
              type="number"
              name="mobile_number"
              placeholder="Mobile Number ..."
              className="border-0 mt-1"
            />
          </div>
        </div>
      </Col>

      {/* ****************************** Name ************************************ */}
      <Col sm={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
            <i className="bx bx-search-alt search-icon " />
            <MultipleValueTextInput
              onItemAdded={(item, allItems) => {
                if (allItems.length > 1) {
                  allItems.pop() // Remove the newly added item
                  return
                }
                setFilteredValues({
                  ...filteredValues,
                  name: item,
                })
              }}
              onItemDeleted={(item, allItems) =>
                setFilteredValues({
                  ...filteredValues,
                  name: "",
                })
              }
              type="text"
              name="name"
              placeholder="Name..."
              className="border-0 mt-1"
            />
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default FilterUsers
